import {
    Checkbox,
    CheckboxIcon,
    CheckboxIndicator,
    HStack,
    Skeleton,
    VStack
} from "@hosttools/frontend/components";
import {CheckIcon} from "@hosttools/frontend/react/components/Icons";
import type React from "react";
import {memo} from "react";

const ListingSkeleton: React.FC = () => {
    return (
        <HStack className="rounded-lg border border-solid border-blueGray-200 p-4" space="lg">
            <Checkbox isDisabled size="md" value="none">
                <CheckboxIndicator>
                    <CheckboxIcon as={CheckIcon} />
                </CheckboxIndicator>
            </Checkbox>
            <HStack className="flex-1" space="sm">
                <Skeleton className="w-12 h-12" />
                <VStack className="flex-1" space="xs">
                    <Skeleton className="w-full h-4" />
                    <Skeleton className="w-1/2 h-4" />
                </VStack>
            </HStack>
        </HStack>
    );
};

export default memo(ListingSkeleton);
